module.exports = __webpack_public_path__ + "static/media/arrow-from-bottom.d5a0fba2.svg";